import { useCurrentStepId } from './useCurrentStepId';

type HookResult<StepId> = {
    currentStepId: StepId;
    navigateToStep: (toStepId: StepId) => void;
};

export const useFocusPageWithStepperNavigation = <StepId>(): HookResult<StepId> => {
    const { currentStepId, dispatchActions } = useCurrentStepId();

    const navigateToStep = (toStepId: StepId): void => {
        dispatchActions.setCurrentStepId(toStepId as unknown as string);
    };

    return {
        currentStepId: currentStepId as unknown as StepId,
        navigateToStep,
    };
};
